// extracted by mini-css-extract-plugin
export default {"variantSelectorSkeleton":"CoDk_","addToBagSkeleton":"Impwc","saveForLaterSkeleton":"Zkbmc","loading":"wylP2","actionsSkeleton":"ataVP","container":"QkQ6k"};